import Numeral from "numeral";

Numeral.register('locale', 'ru', {
    delimiters: {
        thousands: ' ',
        decimal: ','
    },
    abbreviations: {
        thousand: 'тыс',
        million: 'млн',
        billion: 'блн',
        trillion: 'трлн'
    },
    ordinal : function (number) {
        return number === 1 ? 'нечет' : 'чет';
    },
    currency: {
        symbol: '₽'
    }
});

export default
function (value, format = '0a', locale='en') {
    if (!value) return '';

    Numeral.locale(locale);

    const result = Numeral(value);

    return result.format(format);
}